// Lucide icon: flag (https://lucide.dev/icons/flag)
import { Flag } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconFlag = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Flag />
    </IconComponentStyled>
  )
}
